import DiscordIcon from '@/assets/icons/discord.svg?react'
import Telegram from '@/assets/icons/tg.svg?react'
import XIcon from '@/assets/icons/x.svg?react'
import { URLS } from '@/pages/urls'
import { Text, ThemeSwitcher } from '@/ui-kit'
import clsx from 'clsx'
import dayjs from 'dayjs'

const LINKS = [
  {
    name: 'Privacy Policy',
    path: URLS.PRIVACY_POLICY
  },
  {
    name: 'T&Cs',
    path: URLS.TERMS_CONDITIONS
  }
]

export const Footer = ({ className }: { className?: string }) => {
  return (
    <footer
      className={clsx(
        'max-tablet:px-5 max-mobile:flex-col max-mobile:items-center max-mobile:gap-6 relative mb-12 flex w-full items-baseline justify-between px-12',
        className
      )}
    >
      <div className="max-mobile:items-center flex gap-6">
        <ThemeSwitcher />
        {LINKS.map((link) => (
          <a key={link.name} className="group" href={link.path} target="_blank" rel="noreferrer">
            <Text
              className="text-[var(--colorGray80to90)] underline group-hover:text-[var(--color)]"
              type="body3-regular"
            >
              {link.name}
            </Text>
          </a>
        ))}
      </div>
      <div className="max-mobile:-top-12 absolute top-1 left-1/2 -ml-14 flex gap-6">
        <a
          className="hoverScale2x text-[var(--colorGray80to90)] hover:text-[var(--color)]"
          href="https://x.com/datahiveai"
          target="_blank"
          rel="noreferrer"
        >
          <XIcon />
        </a>
        <a
          href="https://t.me/DataHiveAI"
          target="_blank"
          rel="noreferrer"
          className="hoverScale2x text-[var(--colorGray80to90)] hover:text-[var(--color)]"
        >
          <Telegram className="h-6 w-6" />
        </a>
        <a
          href="https://discord.gg/cg8D6UGb7Y"
          target="_blank"
          rel="noreferrer"
          className="hoverScale2x text-[var(--colorGray80to90)] hover:text-[var(--color)]"
        >
          <DiscordIcon className="h-6 w-6" />
        </a>
      </div>

      <Text className="colorGray80to90 whitespace-nowrap" type="body3-regular">
        ©{dayjs().get('year')} DataHive AI. All rights reserved.
      </Text>
    </footer>
  )
}
